import AsyncStorage from "@react-native-async-storage/async-storage";
import { createAsyncStoragePersister } from "@tanstack/query-async-storage-persister";
import type { PersistQueryClientOptions } from "@tanstack/react-query-persist-client";

import { GUEST } from "~/state/sync";

const asyncStoragePersister = createAsyncStoragePersister({
  storage: AsyncStorage,
  key: "gearsync:query-cache",
});

/**
 * Persists only the guest's gear. A guest's items live nowhere but this cache
 * until they create an account (see migrateGuestToRemote), so it must survive
 * a restart and never be aged out. A signed-in user's rows stay online-only.
 */
export const persistOptions: Omit<PersistQueryClientOptions, "queryClient"> = {
  persister: asyncStoragePersister,
  maxAge: Infinity,
  dehydrateOptions: {
    shouldDehydrateQuery: (query) => query.queryKey[1] === GUEST,
    shouldDehydrateMutation: () => false,
  },
};
